"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = last;
var _rest = _interopRequireDefault(require("./rest.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Get the last element of an array. Passing **n** will return the last N
// values in the array.
function last(array, n, guard) {
  if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
  if (n == null || guard) return array[array.length - 1];
  return (0, _rest.default)(array, Math.max(0, array.length - n));
}